<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$( document ).ready(function() {
// popular product slider
$('.popular_product_slider').slick({
  centerMode: true,
  centerPadding: '120px',
  slidesToShow: 3,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0741/8704/7225/files/arrow__left.svg'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0741/8704/7225/files/arrow__right.svg'>",
  responsive: [
    {
      breakpoint: 1380,
      settings: {
        centerMode: true,
        dots: false,
        centerPadding: '90px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1200,
      settings: {
        centerMode: true,
        dots: false,
        centerPadding: '70px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        centerMode: true,
        dots: true,
        centerPadding: '55px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '50px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        dots: true,
        centerPadding: '25px',
        slidesToShow: 1
      }
    }
  ]
});
// Collection List
  $('.collection_sec_main').slick({
  slidesToShow: 3,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0741/8704/7225/files/arrow_-left-blue.svg'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0741/8704/7225/files/arrow-reft.svg'>",
  responsive: [
    {
      breakpoint: 1380,
      settings: {
        dots: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1200,
      settings: {
        dots: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        dots: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 1
      }
    }
  ]
});
// Navigation Menu
$('.toggle_icon_header').on('click', function () {
   $('body').addClass('menu_overly_body')
});
$('div#mySidenav a.closebtn').on('click', function () {
    $('body').removeClass('menu_overly_body')
});
// Body Overly 
$('body.menu_overly_body').on('click', function () {
    $("a.closebtn").trigger("click");
});
// Header sticky
$(window).scroll(function(){
    if ($(window).scrollTop() >= 10) {
        $('body').addClass('fixed-header');
    }
    else {
        $('body').removeClass('fixed-header');
    }
});
// Product Review Section
$('.shopify-section.spaced-section > .page-width').addClass('container');

// Review Right section
$( "<div class='review_form_right_sec'>Review Right section</div>" ).insertAfter( $( ".spr-content > .spr-form form" ) );
// Customer login
$('.login-popup-link').click(function(e) {
    e.preventDefault();
    $('body').append('<div class="login-popup"><div class="login-popup-content"><a href="#" class="close">X</a><h2>Login</h2>{{ form | create_customer }}</div></div>');
    $('.login-popup').fadeIn();
    $('.close, .login-popup').click(function() {
      $('.login-popup').fadeOut(function() {
        $(this).remove();
      });
    });
});
// Animation Call
new WOW().init();
// Instagram section animation
$('div#insta-feed .instafeed-container').addClass('wow fadeInUp');
// Firbox brower class
if(navigator.userAgent.indexOf('Firefox') > -1){
  $("body").addClass("firefox_browser");
  }
// Product Zoom effect
var nativeWidth = 0;
var nativeHeight = 0;

$(".productView-image-wrapper").mousemove(function(e) {
	if (!nativeWidth && !nativeHeight) {
		var imgObject = new Image();
		imgObject.src = $(".product-single__media .media > img").attr("src");
		imgObject.onload = function() {
			nativeWidth = imgObject.width;
			nativeHeight = imgObject.height;
			handleMagnification(e);
		};
	} else {
		handleMagnification(e);
	}
});

function handleMagnification(e) {
	var magnifyOffset = $(".productView-image-wrapper").offset();
	var mouseX = e.pageX - magnifyOffset.left;
	var mouseY = e.pageY - magnifyOffset.top;

	if (
		mouseX < $(".productView-image-wrapper").width() &&
		mouseY < $(".productView-image-wrapper").height() &&
		mouseX > 0 &&
		mouseY > 0
	) {
		$(".magnifier").fadeIn(100);
	} else {
		$(".magnifier").fadeOut(100);
	}

	if ($(".magnifier").is(":visible")) {
		var smallImgX = Math.round(
			(mouseX / $(".product-single__media .media > img").width()) * nativeWidth -
				$(".magnifier").width()
		) * -1;
		var smallImgY = Math.round(
			(mouseY / $(".product-single__media .media > img").height()) * nativeHeight -
				$(".magnifier").height()
		) * -1;
		var bgp = smallImgX + "px " + smallImgY + "px";
		var largeImgX = mouseX - $(".magnifier").width();
		var largeImgY = mouseY - $(".magnifier").height();

		$(".magnifier").css({ left: largeImgX, top: largeImgY, backgroundPosition: bgp });
	}
}
// Lord More buttn text 
setTimeout(function(){ 
  jQuery('span#realoadMore > span').text('Load More');
}, 1500);

});



